import type { ListFilterOption } from '../..';

const optionKey = (value: ListFilterOption['value']) => `${typeof value}:${String(value)}`;

const normalizeOptionValue = (value: unknown): ListFilterOption['value'] | undefined => {
    if (typeof value === 'string') {
        const normalized = value.trim();

        return normalized || undefined;
    }

    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : undefined;
    }

    return typeof value === 'boolean' ? value : undefined;
};

/**
 * Removes unusable API values before they can become empty Select rows or chips.
 * The first value wins so unstable upstream duplicates cannot create ambiguous selections.
 */
export const normalizeListFilterOptions = (options: ListFilterOption[]): ListFilterOption[] => {
    const normalized = new Map<string, ListFilterOption>();

    options.forEach((option) => {
        const value = normalizeOptionValue(option.value);
        const label = typeof option.label === 'string' ? option.label.trim() : option.label;

        if (value === undefined || (typeof label === 'string' && !label)) {
            return;
        }

        const key = optionKey(value);

        if (!normalized.has(key)) {
            normalized.set(key, { ...option, label, value });
        }
    });

    return [...normalized.values()];
};

export { optionKey };
